// Pflichtfelder IBAN und BIC, solange die Zahlungsart nicht "Rechnung" ist.
//
// Die IDs hiessen im femanager-Formular `bw_luftwaffe_payment_method` und so
// weiter. bw_feusers erzeugt `bw-feusers-<spalte>`, deshalb griff die Bedingung
// nach der Abloesung nie mehr und die Logik war lautlos verschwunden. Jetzt
// werden beide Schreibweisen probiert.
//
// Jedes Element wird einzeln geprueft: `bw_luftwaffe_bic` steht gar nicht in der
// Feldauswahl des Profilformulars, und `input.required` auf null wuerde werfen.
function bwFeld(spalte) {
    return document.getElementById("bw-feusers-" + spalte)
        || document.getElementById(spalte);
}

function toggleRequired() {
    var select = bwFeld("bw_luftwaffe_payment_method");
    if (!select) {
        return;
    }
    var pflicht = select.value !== "Rechnung";

    [["bw_luftwaffe_iban", "iban-asterisk"],
     ["bw_luftwaffe_bic", "bic-asterisk"]].forEach(function (paar) {
        var feld = bwFeld(paar[0]);
        if (feld) {
            feld.required = pflicht;
        }
        var stern = document.getElementById(paar[1]);
        if (stern) {
            stern.innerHTML = pflicht ? "<span>*</span>" : "";
        }
    });
}

if (bwFeld("bw_luftwaffe_payment_method")) {
    window.addEventListener("load", function () {
        var selectField = bwFeld("bw_luftwaffe_payment_method");
        if (!selectField) {
            return;
        }
        selectField.addEventListener("change", toggleRequired);
        toggleRequired();
    });
}
